import { render, staticRenderFns } from "./SelectCenter.vue?vue&type=template&id=880bd426&scoped=true&"
import script from "./SelectCenter.vue?vue&type=script&lang=js&"
export * from "./SelectCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880bd426",
  null
  
)

export default component.exports